import React from 'react';
import { toast, ToastContainer } from 'react-toastify';

import { WithDbId } from '../../../../../adl-gen/common/db';
import { Question, Skill } from '../../../../../adl-gen/totalinteraction/futurefit/db';
import { RepositoryEntrySet } from '../../../../../adl-gen/totalinteraction/futurefit/frontend';
import { QuestionCompetencySkillsMap, QuestionStore } from '../../../../stores';
import { toastOptions } from '../../../common/form';
import {
  QuestionAnswerEditor
  // QuestionDeleter
} from '../../editors/question-answer-editor/question-answer-editor';

interface QuestionAnswerFormProps {
  question?: WithDbId<Question>;
  skill?: WithDbId<Skill>;
  competencySkillsMap: QuestionCompetencySkillsMap;
  repository: RepositoryEntrySet;
  store: QuestionStore;
  onCancel(): void;
}

export class QuestionAnswerForm extends React.Component<QuestionAnswerFormProps> {
  create = async (item: Question): Promise<void> => {
    const { competencySkillsMap, onCancel, store } = this.props;

    const toastId = toast.loading('Please wait...', { ...toastOptions, autoClose: 3000 });

    try {
      // const questionId =
      await store.create(item);

      toast.dismiss(toastId);
      let skillName = '';
      if (item.category.kind === 'skill' && item.skillId) {
        const skill = competencySkillsMap.skills.get(item.skillId);
        if (skill) {
          skillName = skill.name.value.en;
        }
      }
      const okMsg =
        item.category.kind === 'skill'
          ? `Question ${item.name} created for skill ${skillName}. Question will be used in future quizzes created using this skill.`
          : `Non-Skill Question ${item.name} created.`;
      toast.success(okMsg, { ...toastOptions, onClose: onCancel, autoClose: 3000 });
    } catch (e) {
      toast.dismiss(toastId);
      toast.error(`Question ${item.name} create failed: ${(e as Error).message}`, {
        ...toastOptions,
        onClose: onCancel
      });
    }
  };

  update = async (item: WithDbId<Question>) => {
    const { onCancel, store } = this.props;

    const toastId = toast.loading('Please wait...', { ...toastOptions, autoClose: 3000 });
    try {
      await store.update(item);

      toast.dismiss(toastId);
      toast.success(`Question ${item.value.name} updated.`, { ...toastOptions, onClose: onCancel, autoClose: 3000 });
    } catch (e) {
      toast.dismiss(toastId);
      toast.error(`Question ${item.value.name} update failed: ${(e as Error).message}`, {
        ...toastOptions,
        onClose: onCancel
      });
    }
  };

  //TODO:  // onDeletes = async (a: DbKey<Question>[]) => {
  //   /// TODO Will fail if following items exist:
  //   ///   - QuizQuestion
  //   ///   - UserQuizQuestionSubmission
  //   ///   - UserQuizQuestionEvent
  //   /// Purge would be required
  //   const { onDelete } = this.props
  //   try {
  //     await onDelete(a)
  //     runInAction(() => (this.fieldState.deletedQuestions = a.slice()))
  //   } catch (e) {
  //     runInAction(() => (this.fieldState.error = e as Error))
  //   }
  // }

  renderContent = () => {
    const {
      competencySkillsMap,
      onCancel,
      question,
      repository,
      skill,
      store
      // toDelete,
    } = this.props;
    // if (deletedQuestions) {
    //   return okHandler(
    //     this.onCancel,
    //     "Delete Questions",
    //     `${deletedQuestions.length} Question` +
    //     (deletedQuestions.length === 1 ? `` : `s`) +
    //     ` deleted.`
    //   )
    // }

    // if (toDelete && toDelete.length > 0) {
    //     return (
    //       <QuestionDeleter
    //         items={toDelete}
    //         onCancel={this.onCancel}
    //         onDelete={this.onDeletes}
    //       />
    //     )
    // } else
    if (question) {
      return (
        <QuestionAnswerEditor
          item={question}
          // skill={skill}
          competencySkillsMap={competencySkillsMap}
          repository={repository}
          onCancel={onCancel}
          onCreate={this.create}
          onUpdate={this.update}
          onUpload={store.uploadRepositoryEntry}
        />
      );
    } else {
      /// Either add new question to selected Skill, or just create new question (skill is undefined)
      return (
        <QuestionAnswerEditor
          skill={skill}
          competencySkillsMap={competencySkillsMap}
          repository={repository}
          onCancel={onCancel}
          onCreate={this.create}
          onUpload={store.uploadRepositoryEntry}
        />
      );
    }
  };

  render() {
    return (
      <React.Fragment>
        <ToastContainer newestOnTop />
        {this.renderContent()}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/components/forms/question-answer-form/question-answer-form.tsx